<template>
  <div>
    <div class="nav-menu nav-menu-user" :class="[isDropdownUserActive ? 'nav-menu-active' : '']">
      <div class="nav-menu-header">
        <div v-if="user.loggedIn">
          <img v-if="user.data.photoURL" :src="user.data.photoURL" class="img-fluid avatar" width="50px"
               height="50px" :alt="user.data.displayName + ' profile picture'">
          <img v-else :src="'https://ui-avatars.com/api/?name=' + user.data.displayName + '&background=random&size=100'"
               class="img-fluid profile-picture" width="100px" alt="Default profile picture">

          <p class="overline text-muted text-truncate mb-0" style="max-width: 200px">
            {{ user.data.displayName || 'Profile' }}
          </p>
        </div>
        <button class="btn btn-link ripple ripple-primary m-0" @click="toggleUserDropdown()">
          <i class="material-icons-outlined">&#xe5cd;</i>
        </button>
      </div>
      <div class="nav-menu-body">
        <router-link to="/profile" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe853;</i>
          <p class="mb-0">Profile</p>
        </router-link>
        <router-link to="/user/gradients" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe23a;</i>
          <p class="mb-0">My gradients</p>
        </router-link>
        <router-link to="/user/likes/gradients" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe87e;</i>
          <p class="mb-0">Liked gradients</p>
        </router-link>
        <router-link to="/user/likes/palettes" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe87e;</i>
          <p class="mb-0">Liked palettes</p>
        </router-link>
      </div>
      <div class="nav-menu-footer">
        <button class="btn btn-danger-light btn-micint-x ripple ripple-dark p-3 px-5" @click="signOut()">
          Sign out
          <i class="material-icons-outlined ms-2">&#xe879;</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'isDropdownUserActive',
    'toggleUserDropdown',
    'user',
    'signOut'
  ]
}
</script>